export type TFeatureFlagKey = 'AUDIT_CENTER' | 'ACTION_ORIENTED_PROGRAMS'

export const FEATURE_FLAG: Record<TFeatureFlagKey, TFeatureFlagKey> = {
  AUDIT_CENTER: 'AUDIT_CENTER',
  ACTION_ORIENTED_PROGRAMS: 'ACTION_ORIENTED_PROGRAMS',
}

export interface IFeatureFlag {
  key: TFeatureFlagKey
  enabled: boolean
  description: string
}
